import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';
// utils
import { aemHostClient } from '../../restClient';
// children
import Breadcrumb from '../common/Breadcrumb/Breadcrumb';
import AddAccount from './AddAccount';
import CreateNewAccount from './AddAccount/CreateNewAccount';
import AddEchannel from './AddEchannel';
import CreateNewEchannel from './AddEchannel/CreateNewEchannel';
import AddGLSproduct from './AddGLSproduct';
import CreateNewGLSproduct from './AddGLSproduct/CreateNewGLSproduct';
import SelectEntity from './SelectEntity';
import CreateNewEntity from './SelectEntity/CreateNewEntity';
//action Creator
import { setDarkTitleBarContent } from '../layouts/actions/actionCreator';

//style
import ConvertEchannel from './AddEchannel/ConvertEchannel';
import './styles.css';

const CreateACase = (props) => {
    const [crumbState, setCrumbState] = useState(1);
    const [showCrumbs, setShowCrumbs] = useState(true);
    const [pageJson, setPageJson] = useState();

    useEffect(() => {
        (async () => {
            const { data } = await aemHostClient("/aemData/formData/json_entities");
            setPageJson(data);
        })();
    }, []);

    const updateBreadCrumbsState = (crumbState, crumbs) => {
        setCrumbState(crumbState);
        setShowCrumbs(true);
    }

    const hideCrumbs = () => {
        setShowCrumbs(false);
    }

    const isClientImplementationManager = () => {
        return (props.roleDetails.role.name === 'Case Worker' || props.roleDetails.role.name === "Admin") && (props.history && props.history.location.state && props.history.location.state.navigatedFrom &&
            props.history.location.state.navigatedFrom === "ci-sow-list")
    }

    return (
        (pageJson !== undefined ?
            <div className="create-a-case-container">
                {showCrumbs ? <Breadcrumb BreadcrumbpageJson={pageJson} steps={crumbState} lang={props.lang} isClientImplementationManager={isClientImplementationManager()} /> : ''}
                <Route path="/create-a-case/select-entity" render={props => (<SelectEntity {...props} pageJson={pageJson} updateBreadCrumbsState={updateBreadCrumbsState} isClientImplementationManager={isClientImplementationManager()} />)} />
                <Route exact path="/create-a-case/create-new-entity" render={props => (<CreateNewEntity {...props} hideCrumbs={hideCrumbs} />)} />
                <Route exact path="/create-a-case/edit-entity" render={props => (<CreateNewEntity {...props} hideCrumbs={hideCrumbs} />)} />

                <Route path="/create-a-case/add-account" render={props => (<AddAccount {...props} updateBreadCrumbsState={updateBreadCrumbsState} />)} />
                <Route exact={true} path="/create-a-case/create-new-account" render={props => (<CreateNewAccount {...props} hideCrumbs={hideCrumbs} />)} />
                <Route path="/create-a-case/create-new-account/:caseId/:accountId" render={props => (<CreateNewAccount {...props} hideCrumbs={hideCrumbs} />)} />

                <Route path="/create-a-case/add-echannel" render={props => (<AddEchannel {...props} updateBreadCrumbsState={updateBreadCrumbsState} />)} />
                <Route exact={true} path="/create-a-case/create-new-echannel" render={props => (<CreateNewEchannel {...props} hideCrumbs={hideCrumbs} />)} />
                <Route exact={true} path="/create-a-case/convert-echannel" render={props => (<ConvertEchannel {...props} hideCrumbs={hideCrumbs} />)} />
                <Route path="/create-a-case/create-new-echannel/:caseId/:echannelId" render={props => (<CreateNewEchannel {...props} hideCrumbs={hideCrumbs} />)} />

                <Route path="/create-a-case/add-gls-product" render={props => (<AddGLSproduct {...props} updateBreadCrumbsState={updateBreadCrumbsState} />)} />
                <Route exact={true} path="/create-a-case/create-new-glsproduct" render={props => (<CreateNewGLSproduct {...props} hideCrumbs={hideCrumbs} />)} />
                <Route path="/create-a-case/create-new-glsproduct/:caseId/:glsProductId" render={props => (<CreateNewGLSproduct {...props} hideCrumbs={hideCrumbs} />)} />
            </div>
            : ''))
};

const mapStateToProps = state => {
    return {
        lang: state.lang,
        roleDetails: state.auth.userDetails.roleDetails
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setDarkTitleBarContent: (...args) => {
            dispatch(setDarkTitleBarContent(...args))
        }
    }
}

CreateACase.propTypes = {
    roleDetails: PropTypes.object,
    lang: PropTypes.object,
    history: PropTypes.object
};


export default connect(mapStateToProps, mapDispatchToProps)(CreateACase);


// WEBPACK FOOTER //
// ./src/components/createAcase/index.js